// Bound both HTTP and body parsing. A network failure is not an unknown tenant.
export async function resolveTenantHost({ signal, timeoutMs = 12000, fetcher = fetch } = {}) {
    const controller = new AbortController();
    const abort = () => controller.abort();
    if (signal?.aborted) controller.abort();
    signal?.addEventListener("abort", abort, { once: true });
    let timer;
    try {
        return await Promise.race([
            (async () => {
                const response = await fetcher("/api/public/tenants/resolve", { credentials: "omit", signal: controller.signal });
                if (!response.ok) throw new Error("Tenant service unavailable");
                const data = await response.json();
                if (!data || typeof data !== "object" || Array.isArray(data) || !("vendor" in data)) throw new Error("Invalid tenant response");
                return data;
            })(),
            new Promise((_, reject) => {
                timer = setTimeout(() => { controller.abort(); reject(new Error("Tenant lookup timed out")); }, timeoutMs);
            }),
        ]);
    } finally {
        clearTimeout(timer);
        signal?.removeEventListener("abort", abort);
    }
}
